import type { PageRow, StatWidget as StatWidgetSpec } from '@developerz/domain';
import type { JSX } from 'solid-js';
import { formatCell } from '../../lib/widget-format';

// `stat` presenter (arc 101 slice 09) — one KPI number pulled from the FIRST
// result row's `value_key`, formatted per the spec, with optional prefix/suffix.
// No rows → the value formats as the empty-cell dash, not an error.
export function StatWidget(props: { spec: StatWidgetSpec; rows: readonly PageRow[] }): JSX.Element {
  const value = (): string => {
    const raw = props.rows[0]?.[props.spec.value_key];
    return `${props.spec.prefix ?? ''}${formatCell(raw, props.spec.format)}${props.spec.suffix ?? ''}`;
  };
  return (
    <div class="widget-stat">
      <span class="widget-stat__value">{value()}</span>
      <span class="widget-stat__label">{props.spec.label}</span>
    </div>
  );
}
